type FieldType = "string" | "number" | "boolean";

interface FieldSchema {
  type: FieldType;
  [key: string]: any;
}

interface SchemaObject {
  [key: string]: FieldSchema | SchemaObject;
}

const getDefaultForType = (type: FieldType): any => {
  switch (type) {
    case "string":
      return "";
    case "number":
      return 0;
    case "boolean":
      return false;
    default:
      return null;
  }
};

const generateTemplateFromSchema = (schema: SchemaObject): Record<string, any> => {
  const result: Record<string, any> = {};

  Object.entries(schema).forEach(([key, value]) => {
    if (value && "type" in value) {
      result[key] = getDefaultForType((value as FieldSchema).type);
    } else if (value && typeof value === "object") {
      result[key] = generateTemplateFromSchema(value as SchemaObject);
    }
  });
  return result;
};

export default generateTemplateFromSchema;
